import { Photo } from "shared/api/types";
import { isVideo } from "shared/attachments/thumbnails";

export const isVideoMimeType = (photo: Photo) =>
  isVideo(photo.contentType ?? "");
